import PropTypes from "prop-types";
import * as React from "react";
import shared from "../../../themeV2/shared.module.css";
import css from "./MiniEvent.module.css";

const MiniEvent = React.memo(function MiniEvent({
  month,
  day,
  title,
  subtitle,
  onClick,
  actionLabel = "Edit",
}) {
  const isInteractive = Boolean(onClick);
  const Tag = isInteractive ? "button" : "div";

  return (
    <Tag
      type={isInteractive ? "button" : undefined}
      className={[
        css.root,
        isInteractive ? css.interactive : undefined,
        isInteractive ? shared.stateLayer : undefined,
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
      aria-label={isInteractive ? `${actionLabel} ${title}` : undefined}
    >
      <div className={css.dateMedallion}>
        <span className={css.month}>{month}</span>
        <span className={css.day}>{day}</span>
      </div>
      <div className={css.info}>
        <p className={css.title}>{title}</p>
        {subtitle && <p className={css.subtitle}>{subtitle}</p>}
      </div>
    </Tag>
  );
});

MiniEvent.propTypes = {
  month: PropTypes.string.isRequired,
  day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  actionLabel: PropTypes.string,
};

export default MiniEvent;
